import YCalendar from '../../../assets/js/YCalendar/YCalendar.min';

// A DIV with id "cal1Container" should already exist on the page
/*Input
* Getting data from the calendar container
* */
var cal1;

window.myFn = function () {
    var arrDates = cal1.getSelectedDates();

    var outputType = "date";
    
    for (var i = 0; i < arrDates.length; ++i) {
        var date = arrDates[i];

        // Work with selected date...
        var displayMonth = date.getMonth() + 1;
        var displayYear = date.getFullYear();
        var displayDate = date.getDate();

        var weekNumber = getWeek(displayYear, (displayMonth - 1), displayDate);

        displayMonth = makeFullDigits(displayMonth);
        displayDate = makeFullDigits(displayDate);
        //alert(displayMonth+"/"+displayDate+"/"+displayYear);

        if (typeof subsite !== "undefined" && typeof subsite === "string" && subsite.length > 0) {
            window.location = "/" + subsite + "/" + displayYear + "/" + displayMonth + "/" + displayDate + "/";
        } else if (outputType == "date") {
            window.location = "/" + displayYear + "/" + displayMonth + "/" + displayDate + "/";
        } else if (outputType == "category") {
            if (loc == "subpages") {
                window.location = "../../" + displayYear + "/" + makeFullDigits(weekNumber) + "/";
            } else {
                window.location = displayYear + "/" + makeFullDigits(weekNumber) + "/";
            }
        }
    }
}

window.makeFullDigits = function(el) {
    if (el < 10) {
        el = "0" + el;
    }
    return el;
}

window.getWeek = function(year, month, day) {
    //lets calc weeknumber the cruel and hard way :D

    //Find JulianDay 

    month += 1; //use 1-12

    var a = Math.floor((14 - (month)) / 12);
    var y = year + 4800 - a;
    var m = (month) + (12 * a) - 3;
    var jd = day + Math.floor(((153 * m) + 2) / 5) +
        (365 * y) + Math.floor(y / 4) - Math.floor(y / 100) +
        Math.floor(y / 400) - 32045;      // (gregorian calendar)

    //var jd = (day+1)+Math.Round(((153*m)+2)/5)+(365+y) + 

    //                 Math.round(y/4)-32083;    // (julian calendar)


    //now calc weeknumber according to JD

    var d4 = (jd + 31741 - (jd % 7)) % 146097 % 36524 % 1461;
    var L = Math.floor(d4 / 1460);
    var d1 = ((d4 - L) % 365) + L;
    var NumberOfWeek = Math.floor(d1 / 7) + 1;
    return NumberOfWeek;
}

function calendar_init() {
    
    var pagedate = $('#cal1Container').attr('data-page-date');
    var mindate = $('#cal1Container').attr('data-min-date');
    var date = $('#cal1Container').attr('data-selected-date');


    var myDate = new Date();

    cal1 = new YAHOO.widget.Calendar("cal1", "cal1Container",
        {
            pagedate: pagedate,
            mindate: mindate,
            maxdate: "" + (myDate.getMonth() + 1) + "/" + myDate.getDate() + "/" + myDate.getFullYear() + ""
        });

//date = month + "/" + day + "/" + year; 	 
//date = "4/15/2008";

    cal1.select(date);

    cal1.render();

    // Later in your application, when you need the selected dates
    cal1.selectEvent.subscribe(myFn);
    
}



//var loc = "<? echo $_GET['loc']; ?>";



export default calendar_init();
